import React from "react";
import { useNavigate } from "react-router-dom";

// Image path
const HERO_IMG = "/assets/images/women-herobanner.webp";

export default function M2THeroBanner() {
  const navigate = useNavigate();
  return (
    <div className="flex w-full flex-col items-center px-0 py-0">
      <div
        className="-mt-32 flex min-h-[250px] w-full max-w-6xl flex-col items-center overflow-hidden rounded-[18px] sm:flex-row"
        style={{ background: "none" }}
      >
        {/* Left: Image */}
        <div
          className="flex h-[350px] w-full flex-shrink-0 items-center justify-center overflow-hidden rounded-t-[18px] bg-white sm:h-[250px] sm:w-[280px] sm:rounded-bl-[18px] sm:rounded-tl-[18px] sm:rounded-tr-none"
          style={{
            borderTopLeftRadius: "18px",
            borderBottomLeftRadius: "18px",
            borderTopRightRadius: "0px", // on mobile
            borderBottomRightRadius: 0, // on mobile
          }}
        >
          <img
            src={HERO_IMG}
            alt="Hero"
            className="h-full w-full object-cover"
            style={{
              borderTopLeftRadius: "18px",
              borderBottomLeftRadius: "18px",
              borderTopRightRadius: "0px",
              borderBottomRightRadius: 0,
              objectFit: "cover",
            }}
          />
        </div>
        {/* Right: Content */}
        <div
          className="flex h-[350px] w-full flex-1 flex-col items-center justify-center rounded-b-[0px] bg-[#176CFF] px-4 py-5 sm:h-[250px] sm:items-start sm:rounded-bl-none sm:rounded-br-[45px] sm:px-6 sm:py-7"
          style={{
            minWidth: 0,
            minHeight: 190,
            borderTopRightRadius: "0px", // on mobile
            borderBottomRightRadius: "0px", // on mobile
            borderBottomLeftRadius: 0, // on mobile
          }}
        >
          <h2 className="mb-2 text-center text-xl font-bold leading-snug text-white sm:mb-3 sm:text-left sm:text-3xl">
            Begin your journey with
            <br />
            <span className="font-bold text-white">Million2Trillion</span> today
          </h2>
          <button
            className="mt-1 inline-flex items-center gap-1 rounded-md bg-white px-5 py-2 text-base font-bold text-[#176CFF] shadow-sm transition hover:bg-yellow-300 hover:text-black sm:text-xl"
            onClick={() => navigate("/waitlist")}
          >
            Get started
            <span className="ml-1">
              <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
                <path
                  stroke="currentColor"
                  strokeWidth="2"
                  d="M5 12h14m-7-7 7 7-7 7"
                />
              </svg>
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
